import { selectTitleWithDescriptionNode } from '@newStore/documentUI/transformContent/genericSelectors';
import { RequiredType, type RootNodeConfig } from '@nodeTypeConfig/configTypes';
import { authorsComponent } from '@nodeTypeConfig/helpers/editComponents/authorsComponent';
import { descriptionComponent } from '@nodeTypeConfig/helpers/editComponents/descriptionComponent';
import { singleContactComponent } from '@nodeTypeConfig/helpers/editComponents/proContactsComponent';
import { publishComponent } from '@nodeTypeConfig/helpers/editComponents/publishComponent';
import { titleComponent } from '@nodeTypeConfig/helpers/editComponents/titleComponent';
import constants from '@store/constants/constants';

const CONTACT_CARD: RootNodeConfig = {
  nodeSelector: selectTitleWithDescriptionNode,
  deleteFromListValidations: [],
  validationRules: [],
  information: {
    definiteArticle: true,
    single: 'Contactkaart',
    plural: 'Contactkaarten',
    icon: require('../../../../img/icons/document.svg'),
  },
  onLoadActions: [],
  createModal: {
    contacts: {
      addUser: false,
      required: true,
      placeholder: 'Selecteer een contactpersoon : type een naam en selecteer uit de lijst',
      queryParams: constants.defaultContactsParameters,
    },
    authors: {
      addUser: true,
      required: true,
    },
    title: {
      hide: true,
    },
  },
  createDefaults: {
    creators: [], // this stops the modal that wants to clear unused properties from wanting to remove creators. (selectContentNodesWithExtraProperties)
  },
  buildingBlocks: [],
  tocTypes: [],
  edit: [
    titleComponent,
    {
      ...descriptionComponent,
      label: 'Functiespecificatie(s), Onderwijsniveau, Regio',
      required: RequiredType.ERROR,
      options: {
        height: 400,
      },
    },
    { ...singleContactComponent, readonly: true },
    publishComponent,
    {
      ...authorsComponent,
      required: RequiredType.ERROR,
    },
  ],
  websiteHref: null,
  isCreatable: true,
  isSearchable: true,
  isImportable: false,
  allowSuggestions: false,
};

export default CONTACT_CARD;
